export default "__VITE_ASSET__116349ce__"